import { TranslateService } from "@ngx-translate/core";
import { SiilaTranslationService } from "../core/services/siila-translation.service";
import { Injector } from "@angular/core";
import { LOCATION_INITIALIZED } from "@angular/common";
import { take } from "rxjs/operators";

export function appInitializerFactory(
  translateService: TranslateService,
  siilaTranslationService: SiilaTranslationService,
  injector: Injector
): () => Promise<unknown> {
  return () =>
    new Promise<unknown>((resolve: (value: unknown) => void) => {
      const locationInitialized = injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );
      locationInitialized.then(() => {
        translateService.addLangs(["pt", "en", "es"]);
        translateService.setDefaultLang("en");
        const url = window.location.pathname;
        // What the URL asks for: the `/lang/<code>` suffix, or — on news-detail
        // routes — the slug WORD, which outranks the suffix (`/news/...` is the
        // English article, `/noticias/...` the pt/es one). Resolving it HERE, at
        // boot, is what makes the article render in the right language on the
        // first paint instead of flashing the deployment default and correcting
        // itself afterwards.
        const urlLang = siilaTranslationService.getLanguageFromPath(url);
        const resolvedLang =
          urlLang || siilaTranslationService.getDefaultLanguage();
        if (urlLang || !validateUrlLang(url)) {
          try {
            localStorage.setItem("currentLanguageHP", resolvedLang);
          } catch (error) {}
          translateService.setDefaultLang(resolvedLang);
        }

        const language = siilaTranslationService.getCurrentLanguage();
        // News-detail routes own their address bar: `DetailNewsComponent`
        // rewrites word + slug + suffix once the article resolves, and it must
        // see the URL as REQUESTED to decide whether that URL earns a 301.
        // Normalizing the `/lang` suffix here would make an off-canonical URL
        // look canonical and silently swallow the redirect.
        siilaTranslationService
          .setLanguage(language, siilaTranslationService.isNewsDetailPath(url))
          .pipe(take(1))
          .subscribe(
            () => resolve(null),
            err => console.error(err),
            () => resolve(null)
          );
      });
    });
}

export function validateUrlLang(url) {
  if (
    url.indexOf("lang/en") >= 0 ||
    url.indexOf("lang/es") >= 0 ||
    url.indexOf("lang/pt-br") >= 0
  ) {
    return true;
  }
  return false;
}
